import type { ProfileStore } from './interfaces'
import type { AgentSlot } from '@app/types/profile/interfaces'

export const actions = {
  setLoading (this: ProfileStore, payload: ProfileStore['loading']): void {
    this.loading = payload
  },
  setUser (this: ProfileStore, payload: ProfileStore['user']): void {
    this.user = payload
  },
  setSlot (this: ProfileStore, payload: AgentSlot): void {
    if (!this.user) return
    this.user = { ...this.user, slot: payload }
  },
  setOptions (this: ProfileStore, payload: ProfileStore['options']): void {
    this.options = payload
  },
  setPrivileges (this: ProfileStore, payload: ProfileStore['privileges']): void {
    this.privileges = payload
  },
  clear (this: ProfileStore): void {
    this.user = null
    this.options = null
    this.privileges = null
  },
}
